import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class EditRecurringTripCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IEditRecurringTripCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/{carrierId}/recurringTrip/{recurringId}/update';

  public override setParameters(parameters: IEditRecurringTripCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{recurringId}',
      parameters.recurringId.toString()
    );
    this._commandBody = {
      carrierId: parameters.carrierId,
      recurringId: parameters.recurringId,
      dateProgrammed: parameters.dateProgrammed,
      recurringPattern: parameters.recurringPattern,
      selectedDaysOfWeek: parameters.selectedDaysOfWeek,
      recurringValue: parameters.recurringValue,
      recurringEnd: parameters.recurringEnd,
      userId: parameters.userId,
      paxQty: parameters.paxQty,
      areaId: parameters.areaId ?? null,
    };
  }
}

export interface IEditRecurringTripCommandParameters extends ICommandParameters {
  carrierId: number;
  recurringId: number;
  dateProgrammed: string;
  recurringPattern: string;
  selectedDaysOfWeek: string[];
  recurringValue: number | null;
  recurringEnd: string;
  userId: number;
  paxQty?: number;
  areaId?: number | null;
}
